import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import React, { useState, useRef, useContext, useEffect } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import imagenLogin from "../assets/img/solicitud.jpg";
import Input from "@mui/material/Input";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import { services } from "../services/api";
import LoaderComponent from "../components/admin/LoaderComponent";
import { NotificacionContext } from "../context/notificacion_context";
import CaptchaAltcha from "../components/CaptchaAltcha";

function Login() {
  const { showNotification } = useContext(NotificacionContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [register, setRegister] = useState(false);

  const [state, setState] = useState({
    usuario: "",
    pass: "",
  });

  const containerRef = useRef(null);
  const captchaRef = useRef(null);

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const permitions = [
    "REGISTRO",
    "BORRAR_ASUNTO",
    "EXPORTACIÓN",
    "RESTCOORDIVA",
    "AUDIENCIA",
    "EXPORTAR_AUDIENCIA",
    "FIRMAR_DOCUMENTOS",
    "SOLO_LECTURA",
    "REVISAR_DOCUMENTOS",
    "GEOLOCALIZACION",
  ];

  const loginHandle = async () => {
    const usuario = state.usuario;
    const password = state.pass;

    setLoader(true);

    if (usuario === "") {
      setLoader(false);

      showNotification(
        "warning",
        "Todos los campos son requeridos",
        "Ingresa un Email",
        null,
        4,
      );

      return;
    }

    if (password === "") {
      setLoader(false);

      showNotification(
        "warning",
        "Todos los campos son requeridos",
        "Ingresa una Contraseña",
        null,
        4,
      );

      return;
    }

    // Captcha invisible: token recién emitido justo antes del login
    // (el reto del backend expira a los ~10 s).
    let captchaToken = "";

    try {
      captchaToken = await captchaRef.current.execute();
    } catch (error) {
      setLoader(false);

      showNotification(
        "error",
        "Verificación fallida",
        "No se pudo completar la verificación de seguridad. Inténtalo de nuevo.",
        null,
        4,
      );

      return;
    }

    try {
      const login = await services({
        method: "POST",
        service: "login",
        body: {
          usuario: state.usuario,
          password: state.pass,
          token: captchaToken,
        },
      });

      if (login.status === 200) {
        setLoader(false);

        localStorage.setItem("rol", login.data.rol);
        localStorage.setItem("nombre", login.data.nombre);
        localStorage.setItem("dependencia", login.data.dependencia);

        permitions.forEach((item) => {
          if (Object.prototype.hasOwnProperty.call(login.data, item)) {
            localStorage.setItem(item, login.data[item]);
          }
        });

        if (login.data.rol === "ADMINISTRADOR") {
          navigate("/inicio");
        } else if (login.data.rol === "DEPENDENCIA") {
          navigate("/inicioDep");
        } else if (login.data.rol === "USUARIO") {
          localStorage.setItem("usuario", login.data.usuario);

          const firmante = localStorage.getItem("FIRMAR_DOCUMENTOS");
          const audiencia = localStorage.getItem("AUDIENCIA");
          const lectura = localStorage.getItem("SOLO_LECTURA");
          const revisorDocumentos = localStorage.getItem("REVISAR_DOCUMENTOS");

          if (lectura) {
            navigate("/inicioUser");
          } else if (firmante || revisorDocumentos) {
            navigate("/firmaUser");
          } else if (audiencia) {
            navigate("/audienciaUser");
          } else {
            navigate("/unauthorized");
          }
        }
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error("Error en login:", error);
      setLoader(false);
    }
  };

  const handleState = ({ target }) => {
    const { value, name } = target;

    setState({
      ...state,
      [name]: value,
    });
  };

  useEffect(() => {
    const rol = localStorage.getItem("rol");

    if (rol !== null) {
      if (rol === "ADMINISTRADOR") {
        navigate("/inicio");
      } else if (rol === "DEPENDENCIA") {
        navigate("/inicioDep");
      } else if (rol === "USUARIO") {
        const firmante = localStorage.getItem("FIRMAR_DOCUMENTOS");
        const audiencia = localStorage.getItem("AUDIENCIA");
        const lectura = localStorage.getItem("SOLO_LECTURA");

        if (lectura) {
          navigate("/inicioUser");
        } else if (firmante) {
          navigate("/firmaUser");
        } else if (audiencia) {
          navigate("/audienciaUser");
        } else {
          navigate("/unauthorized");
        }
      }
    }

    const keyDownHandler = (event) => {
      const btn = document.getElementById("btnLog");

      if (event.key === "Enter" && btn) {
        event.preventDefault();
        btn.click();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [navigate]);

  return (
    <>
      {loader && <LoaderComponent />}

      <div className="card--height--400 d-flex flex-row flex-wrap justify-content-center py-5">
        <div className="d-flex justify-content-center justify-content-md-end mb-3 mb-md-0">
          <img src={imagenLogin} alt="imagenLogin" className="imgLogin" />
        </div>

        <div
          className="d-flex flex-column justify-content-center cardLogin p-3"
          ref={containerRef}
        >
          {!register && (
            <Slide
              direction="right"
              in={!register}
              container={containerRef.current}
            >
              <div>
                <form>
                  <p className="text-guinda text-left text-bolder mt-4">
                    Sistema de Atención Ciudadana
                  </p>

                  <p className="text-guinda text-left w-75">Registro.</p>

                  <div className="d-flex flex-column align-items-center">
                    <FormControl
                      sx={{ m: 1, width: "100%" }}
                      variant="standard"
                    >
                      <InputLabel
                        sx={{ ml: "3px" }}
                        htmlFor="standard-adornment-email"
                      >
                        Usuario
                      </InputLabel>

                      <Input
                        value={state.usuario}
                        name="usuario"
                        onChange={handleState}
                        id="standard-adornment-email"
                        type="text"
                        className="text-guinda"
                      />
                    </FormControl>

                    <FormControl
                      sx={{ m: 1, width: "100%" }}
                      variant="standard"
                    >
                      <InputLabel sx={{ ml: "3px" }} htmlFor="component-simple">
                        Contraseña
                      </InputLabel>

                      <Input
                        value={state.pass}
                        onChange={handleState}
                        name="pass"
                        id="component-simple"
                        type={state.showPassword ? "text" : "password"}
                        className="text-guinda"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                            >
                              {state.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>

                    <CaptchaAltcha ref={captchaRef} />
                  </div>

                  <div className="mt-3 d-flex flex-column justify-content-center">
                    <Button
                      id="btnLog"
                      type="button"
                      onClick={loginHandle}
                      style={{
                        margin: "15px auto",
                        width: "fit-content",
                      }}
                      variant="contained"
                      className="btn-guinda"
                    >
                      Entrar
                    </Button>
                  </div>

                  <span className="mt-4 d-none">
                    ¿No tienes cuenta?,{" "}
                    <strong
                      onClick={() => setRegister(true)}
                      className="text-guinda text-left text-bolder mt-3 cursor-pointer"
                    >
                      Regístrate
                    </strong>
                  </span>
                </form>
              </div>
            </Slide>
          )}
        </div>
      </div>
    </>
  );
}

export default Login;
